import { useEffect, useState } from "react";
import { Copy, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

export const LinksTab = () => {
  const [discounts, setDiscounts] = useState([]);

  useEffect(() => {
    api.get("/admin/discounts").then(({ data }) => setDiscounts(data.filter((d) => d.active))).catch(() => {});
  }, []);

  const linkFor = (code) => `${window.location.origin}/promo/${code}`;

  const copy = async (code) => {
    try {
      await navigator.clipboard.writeText(linkFor(code));
      toast.success("Promo link copied to clipboard");
    } catch {
      toast.error("Could not copy — copy it manually");
    }
  };

  return (
    <div data-testid="links-tab">
      <h2 className="font-display text-xl sm:text-2xl font-bold tracking-tight uppercase mb-2">Promo Links</h2>
      <p className="text-sm text-[#7A7067] mb-8 max-w-xl">
        Share these anywhere — Instagram bio, stories, email. Anyone who opens one gets the discount code applied automatically at checkout.
      </p>
      <div className="space-y-3" data-testid="promo-links-list">
        {discounts.map((d) => (
          <div key={d.id} className="flex flex-col sm:flex-row sm:items-center gap-3 bg-[#171412] border border-[#2C2623] p-4" data-testid={`promo-link-row-${d.code}`}>
            <div className="sm:w-48">
              <p className="font-mono font-bold text-[#E29D47]">{d.code}</p>
              <p className="text-[10px] font-mono uppercase tracking-widest text-[#7A7067]">
                {d.type === "percent" ? `${d.value}% off` : `$${d.value.toFixed(2)} off`}
              </p>
            </div>
            <p className="flex-1 font-mono text-xs text-[#B8AEA5] truncate" data-testid={`promo-link-url-${d.code}`}>{linkFor(d.code)}</p>
            <div className="flex gap-2">
              <button
                onClick={() => copy(d.code)}
                className="flex items-center gap-2 border border-[#2C2623] hover:border-[#E05A36] hover:text-[#E05A36] px-4 py-2 text-xs font-bold uppercase tracking-wider transition-colors"
                data-testid={`promo-link-copy-${d.code}`}
              >
                <Copy className="w-3.5 h-3.5" /> Copy
              </button>
              <a
                href={linkFor(d.code)}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 border border-[#2C2623] hover:border-[#E05A36] hover:text-[#E05A36] px-4 py-2 text-xs font-bold uppercase tracking-wider transition-colors"
                data-testid={`promo-link-open-${d.code}`}
              >
                <ExternalLink className="w-3.5 h-3.5" /> Test
              </a>
            </div>
          </div>
        ))}
        {discounts.length === 0 && (
          <p className="text-center text-[#7A7067] font-mono text-xs uppercase tracking-widest py-12 border border-[#2C2623]">
            No active codes. Create one in the Discount Codes tab first.
          </p>
        )}
      </div>
    </div>
  );
};
